import { render, staticRenderFns } from "./salesOrderHistory.vue?vue&type=template&id=73a7d7a0&scoped=true"
import script from "./salesOrderHistory.vue?vue&type=script&lang=js"
export * from "./salesOrderHistory.vue?vue&type=script&lang=js"
import style0 from "./salesOrderHistory.vue?vue&type=style&index=0&id=73a7d7a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a7d7a0",
  null
  
)

export default component.exports